<template>
  <div class="section-area">
    <div
      v-for="(section) in sections"
      :key="section.id"
      class="section-area__content"
    >
      <table>
        <tbody>
          <tr>
            <th class="fas fa-play-circle" />
            <th
              class="section-seconds"
              @click="jumpToSelectedSeconds(section.seconds); setSecondsQueryInUrl(section.seconds)"
            >
              {{ changeSecondsToHoursMinituesSeconds(section.seconds) }}
            </th>
          </tr>
        </tbody>
      </table>
      <div class="section-title-name">
        <div
          class="section-title"
          @click="jumpToSelectedSeconds(section.seconds)"
        >
          {{ section.title }}
        </div>
        <div
          v-if="section.presenter && section.presenter.name"
          class="section-name"
        >
          by
          <a
            :href="section.presenter.profile_url"
            target="_blank"
          >@{{ section.presenter.name }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventArchiveSectionsRepository from '../entry/api/inside/event_archive_sections_repository'
import * as Sentry from '@sentry/vue'
import Player from '@vimeo/player'
import { ref, onMounted } from 'vue'

export default {
  name: 'EventArchiveEmbeddedVideoMenu',
  props: {
    eventArchiveId: {
      type: String,
      required: true
    },
    iframeElement: {
      type: Object,
      required: true
    }
  },
  setup (props) {
    const sections = ref([])
    const startTime = ref(0)
    let player

    const fetchSections = async () => {
      const response = await EventArchiveSectionsRepository.getEventArchiveSections(props.eventArchiveId)

      console.log(response)
      if (response) { sections.value = response }
    }

    onMounted(() => {
      player = new Player(props.iframeElement)

      const searchParams = new URLSearchParams(window.location.search)
      const paramsTime = searchParams.get('t')

      if (paramsTime) {
        startTime.value = paramsTime
        player.setCurrentTime(startTime.value)
      }

      fetchSections()
    })

    const jumpToSelectedSeconds = (sectionSeconds) => {
      player.setCurrentTime(sectionSeconds)
        .then(() => {
          player.play()
        })
        .catch((error) => {
          Sentry.captureException(error)
        })
    }

    const setSecondsQueryInUrl = (sectionSeconds) => {
      const url = new URL(window.location)
      url.searchParams.set('t', sectionSeconds)
      history.pushState({}, '', url)
    }

    const changeSecondsToHoursMinituesSeconds = (sectionSeconds) => {
      const selectedSeconds = sectionSeconds || 0
      const hours = `00${Math.floor(selectedSeconds / 3600)}`.slice(-2)
      const minutes = `00${Math.floor(selectedSeconds / 60) % 60}`.slice(-2)
      const seconds = `00${Math.floor(selectedSeconds % 60)}`.slice(-2)

      return `${hours}:${minutes}:${seconds}`
    }

    return {
      sections,
      jumpToSelectedSeconds,
      setSecondsQueryInUrl,
      changeSecondsToHoursMinituesSeconds
    }
  }
}
</script>

<style lang="scss">
.section-area__content {
  display: flex;

  .fa-play {
    padding-top: 4px;
  }

  .section-seconds {
    cursor : pointer;
    font-weight: 400;
    font-size: 18px;
    color: #007bff;
    padding-left: 8px;
    word-break: keep-all;
    font-family: monospace, serif;
  }

  .section-title {
    cursor : pointer;
    padding: 2px 0 0 8px;

    &:hover {
      font-weight: 400;
      color: #007bff;
    }
  }

  .section-name {
    padding-left: 8px;
    font-size: 12px;
    color: #aaa;

    a {
      color: #aaa;
      &:hover {
        text-decoration:underline;
      }
    }
  }
  .fa-play-circle {
    font-weight: 200;
  }
}
</style>
